import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import ConfigContext from '../../../contexts/ConfigContext';
import useAuth from '../../../hooks/useAuth';
import { useUserLogoutMutation } from '../../../redux/slices/authSlice';

// Components
import MobileSubMenu from './MobileSubMenu';
import FoodTrucksMenu from './FoodTrucksMenu';
import CateringMenu from './CateringMenu';

import styles from './Header.module.postcss';

function MobileMenu({ cityName, vehicleType, mobileMenuOpen }) {
  const { auth, admin, cateringUser, dashboardLink } = useAuth();
  const addTruckLink = (cityName !== 'Portland') ? '/vendors' : '/vendor/register';

  const [foodTrucksSubNavOpen, setFoodTrucksSubNavOpen] = useState(false);
  const [cateringSubNavOpen, setCateringSubNavOpen] = useState(false);
  const [servicesSubNavOpen, setServicesSubNavOpen] = useState(false);

  const [userLogout] = useUserLogoutMutation();

  const closeSubNavs = () => {
    setFoodTrucksSubNavOpen(false);
    setCateringSubNavOpen(false);
    setServicesSubNavOpen(false);
  };

  useEffect(() => {
    if (!mobileMenuOpen) {
      closeSubNavs();
    }
  }, [mobileMenuOpen]);

  return (
    <>
      <nav
        className={cn(styles.MobileMenu, {
          [styles.MobileMenu_open]: mobileMenuOpen,
        })}
      >

        { !auth.loggedIn &&
          <Link to='/catering/register' className={cn(styles.MobileMenu_Cta, 'Button')}>
            Book Catering
          </Link>
        }

        <button
          type='button'
          className={styles.MobileMenu_Link}
          onClick={() => setFoodTrucksSubNavOpen(true)}
        >
          <div>Food {vehicleType}s</div>
        </button>

        <button
          type='button'
          className={styles.MobileMenu_Link}
          onClick={() => setCateringSubNavOpen(true)}
        >
          <div>Catering</div>
        </button>

        <button
          type='button'
          className={styles.MobileMenu_Link}
          onClick={() => setServicesSubNavOpen(true)}
        >
          <div>Services</div>
        </button>

        { !auth.loggedIn &&
          <Link to={addTruckLink} className={styles.MobileMenu_Link}>
            Add Your {vehicleType}
          </Link>
        }

        { admin &&
          <Link to='/admin' className={styles.MobileMenu_Link}>
            Admin
          </Link>
        }

        { auth.loggedIn && !admin &&
          <Link to={dashboardLink} className={styles.MobileMenu_Link + ' u-mr05'}>
            Dashboard
          </Link>
        }

        { cateringUser &&
          <Link to='/account' className={styles.MobileMenu_Link}>
            Account Settings
          </Link>
        }

        <Link to='/support' className={styles.MobileMenu_Link}>
          Support
        </Link>

        { auth.loggedIn &&
          <button
            type='button'
            onClick={userLogout}
            className={styles.MobileMenu_Link}
          >
            Log Out
          </button>
        }
      </nav>

      <MobileSubMenu
        active={foodTrucksSubNavOpen && mobileMenuOpen}
        onClose={closeSubNavs}
      >
        <FoodTrucksMenu cityName={cityName} vehicleType={vehicleType} />
      </MobileSubMenu>

      <MobileSubMenu
        active={cateringSubNavOpen && mobileMenuOpen}
        onClose={closeSubNavs}
      >
        <CateringMenu />
      </MobileSubMenu>

      <MobileSubMenu
        active={servicesSubNavOpen && mobileMenuOpen}
        onClose={closeSubNavs}
      >
        <div className={styles.Header_Dropdown}>
          <Link to='/services/office-parks'>Office Parks</Link>
          <Link to='/services/residential'>Residential</Link>
          { cityName !== 'Portland' &&
            <Link to='/services/breweries'>Breweries</Link>
          }
        </div>
      </MobileSubMenu>
    </>
  );
}

export default MobileMenu;
